import { CallCenterBucket } from '@/api/callcenter/dashboard';
import { Badge, BadgeProps } from '@/components/ui/elements/badge';

// Exported so tests pin these exact strings rather than re-deriving them.
export const BUCKET_BADGE_COPY: Record<CallCenterBucket, string> = {
  waiting: 'Customer texting/waiting',
  fresh_fifo: 'New lead',
  fresh_lifo: 'New lead — call now',
  fresh_sla: 'New lead', // legacy single fresh bucket, pre-lane-split rows
  callback: 'Follow-up due',
  reengagement: 'Re-engage',
};

// waiting is the highest-urgency bucket (backend-defined ordering) so it gets
// the strongest destructive variant; the rest are lower, distinct urgency
// tiers. fresh_lifo reads hotter than fresh_fifo on purpose: it already
// missed its SLA window, so it's the salvage lane.
const BUCKET_BADGE_VARIANT: Record<CallCenterBucket, BadgeProps['variant']> = {
  waiting: 'destructive',
  fresh_fifo: 'orange',
  fresh_lifo: 'red',
  fresh_sla: 'orange',
  callback: 'blue',
  reengagement: 'gray',
};

type BucketBadgeProps = {
  bucket: CallCenterBucket;
};

export const BucketBadge = ({ bucket }: BucketBadgeProps) => {
  return (
    <Badge variant={BUCKET_BADGE_VARIANT[bucket]} size="sm">
      {BUCKET_BADGE_COPY[bucket]}
    </Badge>
  );
};
